/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__TeamScansCustomersWithProduct } from '../../templates/team-scans-customers-with-product';

@observer
export class Slide06 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-06`}>
        {children}
        <Template__TeamScansCustomersWithProduct label={'Shodan'} />
      </div>
    );
  }
}
